import {AxiosResponse} from "axios";
import {has} from "lodash";
import {ApiResponse, Block, Entry} from "../../contract/notion";
import {HttpMethod} from "../../contract/source";

const DEFAULT_PAGE_SIZE = 500;

export interface FetchOptions {
  client: any;
  options: {
    signal: AbortSignal;
    method: HttpMethod;
    [key: string]: any;
  };
  limit: number;
  res: Block[]|Entry[];
  page: number;
  chunks: number;
  query?: {
    [key: string]: string;
  };
}

export type fetchEntriesDef = (url: string, options: FetchOptions) => Promise<ApiResponse>;
export type getAllEntriesDef = (url: string, options: FetchOptions) => Promise<fetchEntriesDef>;

const getAllEntries: getAllEntriesDef = async (url, {
  client,
  options,
  limit = DEFAULT_PAGE_SIZE,
  res = [],
  page,
  chunks,
  query
}): Promise<fetchEntriesDef> => {
  const params = {
    limit: limit || DEFAULT_PAGE_SIZE,
    page: page || 0,
    ...query
  };

  return client(url, {
    ...options,
    params,
  })
    .then((response: any): AxiosResponse<ApiResponse> => {
      if (!response.data) return;

      const next_chunk: number = (chunks-1);
      const {has_more, next_cursor, ...rest} = response.data;

      // either an array of results, or a single result wrapped in an array
      const results: any = (rest.object === 'list')
        ? rest.results
        : [rest];

      if (next_chunk && has_more) {
        getAllEntries(url, {
          client,
          options,
          limit,
          page: next_cursor,
          chunks: next_chunk,
          query,
          res: [
            ...res,
            ...results,
          ]
        })
      } else {
        response.data.results = [
          ...res,
          ...results,
        ];

        return response;
      }
    });
};

const fetchEntries: fetchEntriesDef = async (url, {
  client,
  options,
  limit,
  page,
  chunks = -1,
  query
}): Promise<ApiResponse> => {
  const response: any = await getAllEntries(url,{
    client,
    options,
    limit,
    page,
    chunks,
    query,
    res: [],
  });

  if (!response || !response.data) throw new Error('Invalid response');

  // consolidate list and single entry responses
  return new Promise(resolve => resolve({
    data: has(response.data, 'data') ? response.data.data : [response.data],
    meta: has(response.data, 'meta') ? response.data.meta : {},
  }));
}

export default fetchEntries;
